export enum ManagedPolicyKind {
  SCHOOL = 'school',
  HOME = 'home'
}
export enum ManagedPolicyStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published'
}
export enum ManagedAction {
  ALLOW = 'allow',
  BLOCK = 'block'
}
export enum ParentGrantStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REVOKED = 'revoked'
}
export enum SettingsRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  PROPOSED = 'proposed',
  COMMITTED = 'committed',
  REJECTED = 'rejected'
}
export enum SafetyAppealStatus {
  UPHOLD = 'uphold_block',
  ALLOW = 'allow_scoped_access',
  REVIEW = 'needs_human_review'
}
export enum ManagedYearFilter {
  ALL = 'all',
  UNASSIGNED = 'unassigned'
}

export enum ManagedBlockingConflictCode {
  SCHOOL_TRANSFER_RECOVERY = 'managed_school_transfer_recovery',
  PARENT_ALREADY_ACCEPTED = 'managed_parent_already_accepted'
}
